export default __webpack_public_path__ + "static/media/MessageSent.f0208087.svg";